import { DISCOVERY_STATE_ACTIONS } from './types';

export const SetShowSearchResults = (flag: boolean) => ({
  type: DISCOVERY_STATE_ACTIONS.SET_SHOW_SEARCH_RESULTS,
  payload: flag,
});
